import {lm} from "../../appContext";
import {TComboboxV2InputStatus} from "../combobox/v2";

export namespace nsObjectDataMutable {

    export function comboboxValidateFn(o: any, s: string) {
        if (!!o) {
            return true
        }
        if (!!s) {
            return 'info'
        }
        return false
    }

    /** Map {@link comboboxValidateFn} onto v2 input chrome. */
    export function comboboxInputStatus(selected: unknown, text: string): TComboboxV2InputStatus {
        const result = comboboxValidateFn(selected, text)
        if (result === false) {
            return 'warning'
        }
        if (result === 'info') {
            return 'info'
        }
        return 'ok'
    }

    /** Seed the combobox input with a stored value when no list item matched; return true to latch info chrome. */
    export function comboboxOnInitialObjectFn(value: string) {
        return (o: any, input: KnockoutObservable<string>) => {
            if (!o) {
                input(value)
            }
            const showInfoState = !o && !!value;
            return showInfoState
        }
    }

    export function comboboxTitleFn(titleFn: Function, o: any, s: string): string {
        if (!!o) {
            return lm.t(titleFn(o)) ?? ''
        }
        if (!!s) {
            return lm.t('tooltip: value does not match any preselections') ?? ''
        }
        return lm.t('invalid value') ?? ''
    }
}
